export const AllCompareRoutes = {
  index: "/compare",
};
